(() => {
  function init(root = document) {
    root.querySelectorAll('.dut-desktop-nav').forEach(nav => {
      if (nav.dataset.enhanced) return;
      nav.dataset.enhanced = 'true';
      const menus = [...nav.querySelectorAll('.dut-mega')];
      let hoverClose;
      function sizeOpenMenus() {
        menus.filter(menu => menu.open).forEach(menu => {
          const panel = menu.querySelector('.dut-mega__panel');
          const anchor = nav.querySelector('.header__menu-item');
          const offsetParent = panel?.offsetParent;
          if (!panel || !anchor || !offsetParent) return;
          const parentLeft = offsetParent.getBoundingClientRect().left;
          const desiredLeft = anchor.getBoundingClientRect().left + 12;
          const left = Math.max(20, Math.min(desiredLeft, document.documentElement.clientWidth - panel.offsetWidth - 20));
          panel.style.setProperty('--dut-menu-left', (left - parentLeft) + 'px');
          panel.style.setProperty('--dut-menu-top', Math.max(0, panel.getBoundingClientRect().top) + 'px');
        });
      }
      window.addEventListener('resize', sizeOpenMenus);
      window.addEventListener('scroll', sizeOpenMenus, { passive: true });
      function close(menu, focus = false) {
        menu.open = false;
        menu.querySelector('summary').setAttribute('aria-expanded', 'false');
        if (focus) menu.querySelector('summary').focus();
      }
      menus.forEach(menu => {
        const summary = menu.querySelector('summary');
        summary.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !matchMedia('(min-width: 990px)').matches) return;
          clearTimeout(hoverClose);
          menu.open = true;
        });
        menu.addEventListener('pointerenter', () => clearTimeout(hoverClose));
        menu.addEventListener('toggle', () => {
          menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
          if (menu.open) {
            menus.filter(other => other !== menu).forEach(other => close(other));
            sizeOpenMenus();
          }
        });
        let keyboardNavigation = false;
        menu.addEventListener('pointermove', event => {
          if (event.pointerType !== 'mouse' || !(event.movementX || event.movementY)) return;
          const resumeHover = keyboardNavigation;
          keyboardNavigation = false;
          const button = event.target.closest('.dut-mega__category');
          if (resumeHover && button) activate(button);
        });
        const buttons = [...menu.querySelectorAll('.dut-mega__category')];
        function activate(button) {
          buttons.forEach(item => {
            const expanded = item === button;
            if (item.classList.contains('dut-mega__category--expandable')) item.dataset.expanded = String(expanded);
            else item.setAttribute('aria-expanded', String(expanded));
            item.querySelector('.dut-mega__category-toggle')?.setAttribute('aria-expanded', String(expanded));
          });
          const controls = button.getAttribute('aria-controls') || button.dataset.controls;
          menu.querySelectorAll('.dut-mega__pane').forEach(pane => pane.hidden = pane.id !== controls);
        }
        buttons.forEach(button => {
          button.addEventListener('click', event => {
            if (event.target.closest('.dut-mega__category-link')) return;
            activate(button);
          });
          button.addEventListener('focusin', () => activate(button));
          button.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && !keyboardNavigation) activate(button); });
          button.addEventListener('keydown', event => {
            keyboardNavigation = true;
            if (event.key === 'ArrowRight') {
              event.preventDefault(); activate(button);
              menu.querySelector('.dut-mega__pane:not([hidden]) a')?.focus();
            } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
              event.preventDefault();
              const step = event.key === 'ArrowDown' ? 1 : -1;
              buttons[(buttons.indexOf(button) + step + buttons.length) % buttons.length].focus();
            }
          });
        });
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); close(menu, true); }
          if (event.key === 'ArrowLeft' && event.target.closest('.dut-mega__pane')) {
            event.preventDefault();
            const active = buttons.find(button => button.getAttribute('aria-expanded') === 'true' || button.dataset.expanded === 'true');
            (active?.matches('a,button') ? active : active?.querySelector('a,button'))?.focus();
          }
        });
        menu.addEventListener('focusout', () => setTimeout(() => { if (!menu.contains(document.activeElement)) close(menu); }, 0));
      });
      nav.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(min-width: 990px)').matches) return;
        clearTimeout(hoverClose);
        const topLevelItem = event.target.closest('.dut-desktop-nav > .list-menu > li');
        if (topLevelItem && !topLevelItem.querySelector(':scope > .dut-mega')) {
          menus.forEach(menu => close(menu));
        }
      });
      nav.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        hoverClose = setTimeout(() => {
          if (!nav.contains(document.activeElement)) menus.forEach(menu => close(menu));
        }, 180);
      });
      nav.addEventListener('pointerenter', () => clearTimeout(hoverClose));
      document.addEventListener('click', event => { if (!nav.contains(event.target)) menus.forEach(menu => close(menu)); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
